import { render, staticRenderFns } from "./import-entities.vue?vue&type=template&id=c96a1ff0"
import script from "./import-entities.vue?vue&type=script&lang=js"
export * from "./import-entities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports